"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultFeatureFlagsWithOverrides = exports.FeatureFlagsContext = exports.defaultFeatureFlags = void 0;
var React = require("react");
exports.defaultFeatureFlags = {
    metricsDataCatalogEnabled: true,
    writableFieldDescriptionsEnabled: true,
    markupEditingEnabled: true,
    personalSpaceEnabled: true,
    externalAssetsWithCRASSEnabled: false,
    dqcertificationVisualDesignEnabled: false,
    fieldDescriptionInheritanceLineageEnabled: true,
    incompleteCustomSqlEnabled: true,
};
exports.FeatureFlagsContext = React.createContext(exports.defaultFeatureFlags);
function defaultFeatureFlagsWithOverrides(overrides) {
    return __assign(__assign({}, exports.defaultFeatureFlags), overrides);
}
exports.defaultFeatureFlagsWithOverrides = defaultFeatureFlagsWithOverrides;
//# sourceMappingURL=FeatureFlagsContext.js.map